<template>
  <j-modal :title="title" :width="462" :visible="visible" :footer="null" @cancel="handleCancel">
    <div class="product-switch" @click="handleSwitchChange">
      <svg :class="check ? 'product-switch-active' : ''" id="ic-24-list" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="36px" height="36px" viewBox="0 0 24 24" ><g id="Group_18712" data-name="Group 18712" transform="translate(-460 -348)"><rect id="Rectangle_10139" data-name="Rectangle 10139" width="24" height="24" transform="translate(460 348)" fill="none"></rect><path id="Union_398" data-name="Union 398" d="M155,1430.026a1,1,0,1,1,0-2h10a1,1,0,1,1,0,2Zm-4,0a1,1,0,1,1,0-2h.01a1,1,0,1,1,0,2Zm4-6a1,1,0,0,1,0-2h10a1,1,0,0,1,0,2Zm-4,0a1,1,0,0,1,0-2h.01a1,1,0,0,1,0,2Zm4-6a1,1,0,1,1,0-2h10a1,1,0,1,1,0,2Zm-4,0a1,1,0,1,1,0-2h.01a1,1,0,1,1,0,2Z" transform="translate(314 -1063.026)"></path></g></svg>
      <svg :class="!check ? 'product-switch-active' : ''" id="ic-24-grid" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="36px" height="36px" viewBox="0 0 24 24"><rect id="area" width="24" height="24" fill="none"></rect><path id="Union_396" data-name="Union 396" d="M216.643,1432a1.5,1.5,0,0,1-1.5-1.5v-3.856a1.5,1.5,0,0,1,1.5-1.5H220.5a1.5,1.5,0,0,1,1.5,1.5v3.856a1.5,1.5,0,0,1-1.5,1.5Zm.3-1.8H220.2v-3.257h-3.257ZM207.5,1432a1.5,1.5,0,0,1-1.5-1.5v-3.856a1.5,1.5,0,0,1,1.5-1.5h3.856a1.5,1.5,0,0,1,1.5,1.5v3.856a1.5,1.5,0,0,1-1.5,1.5Zm.3-1.8h3.257v-3.257H207.8Zm8.842-7.343a1.5,1.5,0,0,1-1.5-1.5V1417.5a1.5,1.5,0,0,1,1.5-1.5H220.5a1.5,1.5,0,0,1,1.5,1.5v3.857a1.5,1.5,0,0,1-1.5,1.5Zm.3-1.8H220.2V1417.8h-3.257Zm-9.443,1.8a1.5,1.5,0,0,1-1.5-1.5V1417.5a1.5,1.5,0,0,1,1.5-1.5h3.856a1.5,1.5,0,0,1,1.5,1.5v3.857a1.5,1.5,0,0,1-1.5,1.5Zm.3-1.8h3.257V1417.8H207.8Z" transform="translate(-202 -1411.974)"></path></svg>
    </div>
    <div :class="[`product-list-root`, check ? `product-horizontal-list` : `product-vertical-list`]">
      <!--    product-horizontal-item  product-vertical-item  -->
      <figure class="product-item" v-for="item in record" :key="item.id">
        <picture class="product-cover" :style="{ backgroundImage: `url(${getImgViewCode(item.thumbnail)})` }"></picture>
        <figcaption class="product-information">
          <div class="product-name">
            {{ item.name }}
          </div>
          <dl class="product-field">
            <dt class="product-field-label">供應商家</dt>
            <dl class="product-field-value">{{ item.businessName }}</dl>
          </dl>
          <dl class="product-field">
            <dt class="product-field-label">{{ item.virtual == 0 ? '尚餘數量' : '捐助總額' }}</dt>
            <dl class="product-field-value">{{ item.virtual == 0 ? '1000組' : '1000元' }}</dl>
          </dl>
          <dl class="product-field">
            <dt class="product-field-label">市售價</dt>
            <dl class="product-field-value">{{ item.marketPrice ? '$'+item.marketPrice:'$1000' }}</dl>
          </dl>
          <dl class="product-action">
            <dt class="product-price">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 16 16"
                size="16" color="#D5A85F" data-v-5d0cdcb4="">
                <g id="ic-honhaimoney-red" transform="translate(0 0.296)">
                  <path id="Subtraction_9" data-name="Subtraction 9"
                    d="M-2494,2102.7a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8A8.009,8.009,0,0,1-2494,2102.7Zm-1.508-7.333h3.015v3.333h1.993v-8h-1.993v3.179h-3.015V2090.7h-1.992v8h1.992v-3.333Z"
                    transform="translate(2502 -2087)"></path>
                </g>
              </svg>
              {{ item.price }}
            </dt>
            <dl class="product-buy">立即訂</dl>
          </dl>
        </figcaption>
      </figure>
    </div>
  </j-modal>
</template>

<script>
import { getFileAccessHttpUrl } from '@/api/manage'
export default {
  name: 'PreviewProductListModal',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
    },
    record: {
      type: Array,
    },
  },
  data() {
    return {
      title: '商品预览',
      check: true
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    getImgViewCode(text) {
      if (text && text.indexOf(",") > 0) {
        text = text.substring(0, text.indexOf(","))
      }
      return getFileAccessHttpUrl(text, 'gift')
    },
    close() {
      this.$emit('close');
    },
    handleCancel() {
      this.close()
    },
    handleSwitchChange() {
      this.check = !this.check
    },
  }
}
</script>

<style scoped lang="less">
ol,
ul,
dl {
  margin-bottom: 0;
}

.product-switch{
  width: 76px;
  height: 40px;
  line-height: 40px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  background: #F5F5F5 0% 0% no-repeat padding-box;
  border-radius: 8px;
  padding: 2px;
  box-sizing: border-box;
  cursor: pointer;
  margin-bottom: 12px;
  margin-left: auto;
  svg{
    padding: 6px;
    color: #888;
    fill: #888;
  }
  .product-switch-active{
    border-radius: 8px;
    background: #FFF4EB 0% 0% no-repeat padding-box;
    border-radius: 6px;
    color: #EF7843;
    fill: #EF7843;
  }
}
.product-list-root {
  display: grid;
  padding: 20px;
  background: #F5F5F5 0% 0% no-repeat padding-box;
  width: 100%;
  max-height: 896px;
  overflow-y: auto;
  //border: 1px solid #888888;
  border-radius: 12px;

  &::-webkit-scrollbar {
    max-width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #EF7843;
  }

  &::-webkit-scrollbar-track {
    border-radius: 4px;
    background: #ededed;
  }

  .product-item {
    position: relative;
    overflow: hidden;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    .product-cover {
      background-origin: border-box;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url(/src/assets/svg/img-default.svg);
      background-color: #DDDDDD;
    }
    .product-information {
      padding: 8px 12px;

      .product-name {
        height: 42px;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        font: normal normal bold 14px/21px Noto Sans;
        letter-spacing: 0px;
        color: #2F2F2F;
        text-align: left;
        margin-bottom: 4px;
      }

      .product-field {
        display: flex;
        align-items: center;
        justify-content: left;
        font: normal normal normal 12px/18px Noto Sans;
        letter-spacing: 0px;
        color: #888888;
        text-align: left;

        &-label {
          white-space: nowrap;
          margin-right: 8px;
          width: 48px;
        }

        &-value {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex-basis: 1px;
          flex-grow: 1;
          flex-shrink: 1;
          width: 1px;
        }
      }

      .product-action {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 4px;

        .product-price {
          position: relative;
          overflow: hidden;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          text-align: left;
          font: normal normal bold 14px/21px Noto Sans;
          letter-spacing: 0px;
          color: #D5A85F;
        }

        .product-buy {
          padding: 6px 16px;
          background: #EF8455 0% 0% no-repeat padding-box;
          border-radius: 8px;
          text-align: center;
          font: normal normal bold 14px/21px Noto Sans;
          letter-spacing: 0.22px;
          color: #FFFFFF;
          cursor: pointer;
        }
      }
    }
  }
}
.product-horizontal-list{
  grid-template-columns: 1fr;
  .product-item{
    display: grid;
    grid-template-columns: 134px minmax(0, 1fr);
    border-radius: 8px 0px 0px 8px;
    .product-cover {
      height: 134px;
    }
  }
}
.product-vertical-list{
  grid-column-gap: 12px;
  grid-template-columns: 1fr 1fr;
  .product-item{
    display: grid;
    grid-template-rows: 220px minmax(0, auto);
    border-radius: 10px;
    .product-cover {
      height: 220px;
    }
    .product-information{
      .product-name{
        height: 42px;
        margin-bottom: 4px;
      }
      .product-field{
        display: none;
        opacity: 0;
        visibility: hidden;
      }
    }
  }
}
</style>